<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">发生涉旅负面舆情情况</div>
        <div class="branch" v-if="recordList.length>0">-1.75</div>
        <!-- 没有扣分记录 -->
        <div v-if="recordList.length==0" class="no-de">未扣分</div>
      </div>
      <div class="rules">
        <div class="tit" @click="navTo()">
          <span>评分细则</span>
          <img class="r-img" src="../../assets/image/t-right.png" />
        </div>
        <div class="num">11.25/13.0</div>
      </div>
    </div>
    <!-- 没有扣分记录提示 -->
    <div v-if="recordList.length==0" class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
    <template v-if="recordList.length>0">
      <deducList :recordList="recordList" @navToDetail="navToDetail"></deducList>
    </template>
  </div>
</template>
<script>
  // import Vue from 'vue';
    import nodata from './components/nodata';// 没有数据
    import deducList from './components/deducList';// 扣分列表
    import {} from 'vant';
    // Vue.use(Picker);
    export default {
        components: {
            nodata,
            deducList
        },

        data () {
            return {
                id: '1',
                noData: {
                    title: '没有扣分记录'
                },
                recordList: [
                    {
                        subName: '综合调度指挥中心建立情况',
                        subList: [
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            }
                        ]
                    },
                    {
                        subName: '综合调度指挥中心建立情况',
                        subList: [
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            }
                        ]
                    },
                    {
                        subName: '综合调度指挥中心建立情况',
                        subList: [
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            },
                            {
                                deductionReason: '州市未建立由政府副秘书长或办公室',
                                deduction: '-1.0',
                                accidentTime: '2019-11-01 12:31:22'
                            }
                        ]
                    }
                ]
            }
        },

        computed: {},

        watch: {},

        methods: {
            navTo () {
                this.$router.push({
                    path: '/appraise/scoringList',
                    query: {}
                });
            },
            navToDetail () {
                this.$router.push({
                    path: '/appraise/deductionDetail-negative',
                    query: {}
                });
            }
        },

        mounted () {},

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: #FBFBFB;
    display: flex;
    flex-direction: column;
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }

    .head {
      background: #fff;
      padding: 24px 12px;
      margin-bottom: 24px;

      .title {
        height: 22px;
        line-height: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }

        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 22px;
        }
        .no-de{
          font-size:20px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(54,179,116,1);
          line-height:22px;
        }
      }

      .rules {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        color: #666666;
        font-size: 14px;

        .tit {
          display: flex;
          color: #999;
          font-size: 12px;

          .r-img {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
        .num{
          color: #999999;
        }
      }
    }

  }
</style>
